import { render, staticRenderFns } from "./MoazagotlView.vue?vue&type=template&id=e2a8a87e&scoped=true&"
import script from "./MoazagotlView.vue?vue&type=script&lang=js&"
export * from "./MoazagotlView.vue?vue&type=script&lang=js&"
import style0 from "./MoazagotlView.vue?vue&type=style&index=0&id=e2a8a87e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a8a87e",
  null
  
)

export default component.exports